export const MENU = ["menu", "inner-container", "dropdown"];
